import { civilIdCharactersMinimum } from "../constants/registerConstants";

export const validateCivilId = (id: number): boolean => {
    if (isNaN(id)) {
        return false;
    }

    const idStr = id.toString();
 
    if (idStr.length !== civilIdCharactersMinimum) {
        return false;
    }
 
    const century = parseInt(idStr[0], 10);
    if (century !== 2 && century !== 3) {
        return false;
    }
 
    const year = parseInt(idStr.substring(1, 3), 10);
    const month = parseInt(idStr.substring(3, 5), 10);
    const day = parseInt(idStr.substring(5, 7), 10);
 
    const fullYear = century === 2 ? 2000 + year : 1900 + year;
  
    const date = new Date(fullYear, month - 1, day);
    if (
        date.getFullYear() !== fullYear ||
        date.getMonth() + 1 !== month ||
        date.getDate() !== day
    ) {
        return false;
    } 

    return true;
};
